let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g1Qck")).then(() => parcelRequire('9NAtJ'));